export default __webpack_public_path__ + "assets/images/a6ab38b76a286324beccb4f3fc89dd5a.jpg";